// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/fee_structure_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/images/fee_structure_bg_light.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AGCX Fees Page Styling - Color Theme Compliant */

.fees-container {
  max-width: 1200px;
  margin: 0 auto;
}

/* Main Navigation Tabs */
.fees-nav-tabs {
  display: flex;
  gap: 12px;
  margin-bottom: 28px;
  padding-bottom: 14px;
  flex-wrap: wrap;
}


.fees_structure_page {
  background-size: contain;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: top right;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
}

/* Hero Header & Overview Card Section */
.fees_structure_hero_sec {
  padding-top: 40px;
  padding-bottom: 20px;
}

.fees-gold-pill {
  width: 36px;
  height: 8px;
  background: #D1AA67;
  border-radius: 4px;
  margin-bottom: 16px;
  box-shadow: 0px 0px 10px rgb(209 170 103 / 70%);
}

.fees-hero-title {
  font-size: 65px;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 12px;
  line-height: 1.15;
}

body.light_theme .fees-hero-title {
  color: #1e2329;
}

.fees-hero-title .gold-text {
  background: linear-gradient(0deg, #fff 0%, #D1AA67 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 800;
}

.fees-hero-subtitle {
  color: #9CA3AF;
  font-size: 22px;
  max-width: 480px;
  line-height: 1.5;
  margin-bottom: 0;
}

body.light_theme .fees-hero-subtitle {
  color: #707a8a;
}

.fees-hero-vector-img {
  max-width: 100%;
  height: auto;
  max-height: 300px;
  object-fit: contain;
}

/* Overview Box Card */
.fees-overview-card {
  background: rgb(255 255 255 / 5%);
  -webkit-backdrop-filter: blur(1px);
  margin-top: 10px;
  backdrop-filter: blur(1px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 24px;
  padding: 48px;
  margin-bottom: 80px;
  box-shadow: inset 0 5px 20px rgba(0, 0, 0, 0.35);
}

body.light_theme .fees_structure_hero_sec {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

body.light_theme .fees-overview-card {
  background: rgb(0 0 0 / 05%);
  border-color: #e6e8ea;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
}

body.light_theme .fees-hero-title .gold-text {
  background: linear-gradient(0deg, #000000 0%, #D1AA67 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* AGCX Fee Left Box */
.agcx-fee-box {
  display: flex;
  align-items: flex-start;
  gap: 30px;
  padding-right: 15px;
}

.agcx-fee-icon-wrap {
  min-width: 100px;
  width: 100px;
  height: 100px;
  background: rgb(209 170 103 / 5%);
  border: 1px solid rgb(209 170 103 / 40%);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

body.light_theme .agcx-fee-icon-wrap {
  background: rgba(201, 168, 76, 0.08);
  border-color: rgba(201, 168, 76, 0.5);
}

.agcx-fee-icon {
  width: 36px;
  height: 36px;
  object-fit: contain;
}

.agcx-fee-title {
  font-size: 36px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 6px;
}

body.light_theme .agcx-fee-title {
  color: #1e2329;
}

.agcx-fee-desc {
  width: 80%;
  font-size: 20px;
  color: #A3A3A3;
  line-height: 1.5;
  margin-bottom: 0;
}

body.light_theme .agcx-fee-desc {
  color: #262626;
}

/* Fee Types Right Box */
.fee-types-box {
  padding-left: 10px;
}

.fee-types-heading {
  font-size: 22px;
  font-weight: 500;
  color: #eaecef;
  margin-bottom: 18px;
}

body.light_theme .fee-types-heading {
  color: #1e2329;
}

.fee-types-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding-top: 12px;
}

.fee-type-item {
  display: flex;
  align-items: center;
  gap: 16px;
}

.fee-type-icon {
  width: 24px;
  object-fit: contain;
  margin-top: 0px;
}

.fees_icon_wrap {
  width: 40px;
  min-width: 40px;
  height: 40px;
  border: 1px solid rgb(209 170 103 / 70%);
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.fee-type-text {
  font-size: 17px;
  line-height: 1.5;
}

.fee-type-name {
  color: #D1AA67;
  font-weight: 500;
}

/* body.light_theme .fee-type-name {
  color: #b58d24;
} */

.fee-type-desc {
  color: #A3A3A3;
}

body.light_theme .fee-type-desc {
  color: #2c2c2c;
}


.fees-card {
  color: #fff;
}

body.light_theme .fees-card {
  color: #181818;
}

body.light_theme .fees-nav-tabs {
  border-bottom-color: #e6e8ea;
}

.fees-tab-btn {
  background: #181a20;
  border: 1px solid #2b313a;
  color: #848e9c;
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.25s ease;
}

body.light_theme .fees-tab-btn {
  background: #f8f9fa;
  border-color: #e6e8ea;
  color: #707a8a;
}

body.light_theme .fees-tab-btn.active {
  background: rgb(201 168 76 / 80%);
  color: #000000;
  font-weight: 600;
  border-color: rgb(201 168 76 / 60%);
  box-shadow: 0 4px 14px rgba(240, 185, 11, 0.20);
}

.fees-tab-btn:hover {
  color: #E8C97A;
  border-color: rgb(232 201 122 / 25%);
  background: rgb(232 201 122 / 10%);
}

.fees-tab-btn.active {
  background: #C9A84C;
  color: #000000;
  font-weight: 600;
  border-color: #C9A84C;
  box-shadow: 0 4px 14px rgba(240, 185, 11, 0.20);
}

/* Card Container */
.fees-card {
  background: #181a20;
  border: 1px solid #2b313a;
  border-radius: 12px;
  padding: 26px;
  margin-bottom: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
}

body.light_theme .fees-card {
  background: #ffffff;
  border-color: #e6e8ea;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
}

.fees-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 22px;
  padding-bottom: 14px;
  border-bottom: 1px solid #2b313a;
  flex-wrap: wrap;
  gap: 12px;
}

body.light_theme .fees-card-header {
  border-bottom-color: #e6e8ea;
}

.fees-card-title {
  font-size: 1.35rem;
  font-weight: 600;
  color: #eaecef;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

body.light_theme .fees-card-title {
  color: #1e2329;
}

.fees-badge {
  background: rgba(240, 185, 11, 0.05);
  color: #E8C97A;
  font-size: 0.75rem;
  padding: 4px 12px;
  border-radius: 20px;
  border: 1px solid rgba(240, 185, 11, 0.3);
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

/* Search Box Styling */
.fees-search-box {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 240px;
}

.fees-search-icon {
  position: absolute;
  left: 12px;
  color: #848e9c;
  font-size: 1rem;
  pointer-events: none;
}

.fees-search-input {
  width: 100%;
  background: #1e2329;
  border: 1px solid #2b313a;
  border-radius: 8px;
  padding: 8px 36px 8px 36px;
  color: #eaecef;
  font-size: 0.88rem;
  outline: none;
  transition: all 0.2s ease;
}

body.light_theme .fees-search-input {
  background: #f8f9fa;
  border-color: #e6e8ea;
  color: #1e2329;
}

.fees-search-input:focus {
  border-color: #E8C97A;
  box-shadow: 0 0 0 2px rgba(232, 201, 122, 0.15);
}

.fees-search-input::placeholder {
  color: #848e9c;
}

.fees-search-clear {
  position: absolute;
  right: 10px;
  background: transparent;
  border: none;
  color: #848e9c;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}

.fees-search-clear:hover {
  color: #eaecef;
}

/* Subtab Group */
.fees-subtab-group {
  display: flex;
  gap: 10px;
  margin-bottom: 22px;
  flex-wrap: wrap;
}

.fees-subtab-btn {
  background: #1e2329;
  border: 1px solid #2b313a;
  color: #848e9c;
  padding: 8px 20px;
  border-radius: 6px;
  font-size: 0.88rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

body.light_theme .fees-subtab-btn {
  background: #f8f9fa;
  border-color: #e6e8ea;
  color: #707a8a;
}

body.light_theme .fees-subtab-btn.active {
  background: rgba(240, 185, 11, 0.10);
  color: #E8C97A;
  border-color: rgb(232 201 122 / 50%);
  font-weight: 500;
}

.fees-subtab-btn:hover {
  color: #d4b25a;
  border-color: rgba(240, 185, 11, 0.15);
}

.fees-subtab-btn.active {
  background: rgba(240, 185, 11, 0.10);
  color: #E8C97A;
  border-color: rgb(232 201 122 / 50%);
  font-weight: 500;
}

/* Table Styling (Desktop) */
.fees-table-responsive {
  width: 100%;
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid #2b313a;
}

body.light_theme .fees-table-responsive {
  border-color: #e6e8ea;
}

.fees-custom-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0;
  background: #181a20;
}

body.light_theme .fees-custom-table {
  background: #ffffff;
}

.fees-custom-table th {
  background: #1e2329;
  color: #848e9c;
  font-weight: 600;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 14px 18px;
  border-bottom: 1px solid #2b313a;
  text-align: left;
}

body.light_theme .fees-custom-table th {
  background: #f8f9fa;
  color: #707a8a;
  border-bottom-color: #e6e8ea;
}

.fees-custom-table td {
  padding: 14px 18px;
  color: #eaecef;
  font-size: 0.9rem;
  border-bottom: 1px solid #2b313a;
  vertical-align: middle;
}

body.light_theme .fees-custom-table td {
  color: #1e2329;
  border-bottom-color: #e6e8ea;
}

.fees-custom-table tbody tr:last-child td {
  border-bottom: none;
}

.fees-custom-table tbody tr:hover {
  background: rgba(255, 255, 255, 0.03);
}

body.light_theme .fees-custom-table tbody tr:hover {
  background: #f8f9fa;
}

/* VIP Tier Badges */
.vip-tier-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  min-width: 75px;
  text-align: center;
}

.vip-regular {
  background: rgba(132, 142, 156, 0.15);
  color: #848e9c;
  border: 1px solid rgba(132, 142, 156, 0.3);
}

.vip-1 {
  background: rgba(14, 203, 129, 0.15);
  color: #0ecb81;
  border: 1px solid rgba(14, 203, 129, 0.3);
}

.vip-2 {
  background: rgba(59, 130, 246, 0.15);
  color: #3b82f6;
  border: 1px solid rgba(59, 130, 246, 0.3);
}

.vip-3 {
  background: rgba(168, 85, 247, 0.15);
  color: #a855f7;
  border: 1px solid rgba(168, 85, 247, 0.3);
}

.vip-4 {
  background: rgba(249, 115, 22, 0.15);
  color: #f97316;
  border: 1px solid rgba(249, 115, 22, 0.3);
}

.vip-5 {
  background: rgba(240, 185, 11, 0.2);
  color: #f0b90b;
  border: 1px solid rgba(240, 185, 11, 0.4);
}

/* Fiat Rules Cards */
.fiat-rules-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 24px;
}

.fiat-rule-card {
  background: #1e2329;
  border: 1px solid #2b313a;
  border-left: 4px solid #E8C97A;
  border-radius: 8px;
  padding: 20px;
}

body.light_theme .fiat-rule-card {
  background: #f8f9fa;
  border-color: #e6e8ea;
  border-left-color: #E8C97A;
}

.fiat-rule-card h4 {
  color: #E8C97A;
  font-size: 1.02rem;
  font-weight: 600;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.fiat-rule-card ul {
  margin: 0;
  padding-left: 18px;
  color: #b7bdc6;
  font-size: 0.88rem;
  line-height: 1.65;
}

body.light_theme .fiat-rule-card ul {
  color: #474d57;
}

.fiat-rule-card ul li {
  margin-bottom: 8px;
}

.fiat-rule-card ul li:last-child {
  margin-bottom: 0;
}

/* Trading Footnote */
.trading-footnote {
  margin-top: 16px;
  padding: 12px 16px;
  background: #1e2329;
  border-radius: 6px;
  font-size: 0.83rem;
  color: #848e9c;
  border-left: 3px solid #E8C97A;
}

body.light_theme .trading-footnote {
  background: #f8f9fa;
  color: #707a8a;
}

.fee-highlight-val {
  font-weight: 600;
  color: #0ecb81;
}

.fee-highlight-charge {
  font-weight: 600;
  color: #E8C97A;
}

/* General Mobile Card View Styles */
.fees-mobile-cards {
  display: none;
}

/* DEDICATED Scoped Styles ONLY for Withdrawal Fees Tab */
.fees-withdrawal-mobile-cards {
  display: none;
}

@media (max-width: 768px) {
  .fees-card {
    padding: 16px;
  }

  .fees-search-box {
    width: 100%;
    min-width: 100%;
    margin-top: 8px;
  }

  .fees-tab-btn {
    padding: 8px 20px;
    font-size: 14px;
  }

  .fees-mobile-card-body-2col>div {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .fees-table-responsive {
    display: none !important;
  }

  .fees-mobile-cards {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .fees-mobile-card-item {
    background: #1e2329;
    border: 1px solid #2b313a;
    border-radius: 10px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  body.light_theme .fees-mobile-card-item {
    background: #f8f9fa;
    border-color: #e6e8ea;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  }

  .fees-mobile-card-title {
    font-size: 0.95rem;
    font-weight: 600;
    color: #eaecef;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }

  body.light_theme .fees-mobile-card-title {
    color: #1e2329;
    border-bottom-color: #e6e8ea;
  }

  .fees-mobile-card-header {
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: space-between;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }

  body.light_theme .fees-mobile-card-header {
    border-bottom-color: #e6e8ea;
  }

  .fees-mobile-sub-label {
    font-size: 0.85rem;
    text-align: right;
    color: #848e9c;
    font-weight: 500;
  }

  .fees-mobile-card-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px dashed rgba(255, 255, 255, 0.08);
  }

  .fees-mobile-card-row:last-child {
    border-bottom: none;
  }

  body.light_theme .fees-mobile-card-row {
    border-bottom-color: rgba(0, 0, 0, 0.06);
  }

  .fees-mobile-label {
    font-size: 0.82rem;
    color: #848e9c;
    font-weight: 500;
  }

  body.light_theme .fees-mobile-label {
    color: #707a8a;
  }

  .fees-mobile-value {
    font-size: 0.88rem;
    font-weight: 600;
    color: #eaecef;
    text-align: right;
  }

  body.light_theme .fees-mobile-value {
    color: #1e2329;
  }

  /* Specific styles for Withdrawal Fees Tab cards ONLY */
  .fees-withdrawal-mobile-cards {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .fees-withdrawal-card-item {
    background: #1e2329;
    border: 1px solid #2b313a;
    border-radius: 10px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  body.light_theme .fees-withdrawal-card-item {
    background: #f8f9fa;
    border-color: #e6e8ea;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  }

  .fees-withdrawal-card-title {
    font-size: 1.05rem;
    font-weight: 700;
    color: #E8C97A;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }

  body.light_theme .fees-withdrawal-card-title {
    color: #1e2329;
    border-bottom-color: #e6e8ea;
  }

  .fees-withdrawal-card-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px dashed rgba(255, 255, 255, 0.08);
  }

  .fees-withdrawal-card-row:last-child {
    border-bottom: none;
  }

  body.light_theme .fees-withdrawal-card-row {
    border-bottom-color: rgba(0, 0, 0, 0.06);
  }

  .fees-withdrawal-label {
    font-size: 0.82rem;
    color: #848e9c;
    font-weight: 500;
  }

  body.light_theme .fees-withdrawal-label {
    color: #707a8a;
  }

  .fees-withdrawal-value {
    font-size: 0.88rem;
    font-weight: 600;
    color: #eaecef;
    text-align: right;
  }

  body.light_theme .fees-withdrawal-value {
    color: #1e2329;
  }
}

/* FAQ Section Styles */
.fees-faq-container {
  margin-top: 40px;
  background: #181a20;
  border: 1px solid #2b313a;
  border-radius: 12px;
  padding: 32px;
  margin-bottom: 50px;
}

body.light_theme .fees-faq-container {
  background: #ffffff;
  border-color: #e6e8ea;
}

.fees-faq-header {
  margin-bottom: 28px;
}

.fees-faq-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #eaecef;
  margin-bottom: 6px;
}

body.light_theme .fees-faq-title {
  color: #1e2329;
}

.fees-faq-subtitle {
  font-size: 0.92rem;
  color: #848e9c;
  margin: 0;
}

.fees-faq-list {
  display: flex;
  flex-direction: column;
}

.fees-faq-item {
  border-bottom: 1px solid #2b313a;
  padding: 20px 0;
}

.fees-faq-item:last-child {
  border-bottom: none;
}

body.light_theme .fees-faq-item {
  border-bottom-color: #e6e8ea;
}

.fees-faq-question-btn {
  width: 100%;
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  text-align: left;
  cursor: pointer;
}

.fees-faq-question-text {
  font-size: 1.1rem;
  font-weight: 600;
  color: #eaecef;
  transition: color 0.2s;
}

body.light_theme .fees-faq-question-text {
  color: #1e2329;
}

.fees-faq-icon {
  color: #848e9c;
  font-size: 1.25rem;
  transition: color 0.2s ease;
}

.fees-faq-question-btn:hover .fees-faq-icon {
  color: #E8C97A;
}

.fees-faq-answer {
  margin-top: 14px;
  color: #b7bdc6;
  font-size: 0.92rem;
  line-height: 1.65;
}

body.light_theme .fees-faq-answer {
  color: #474d57;
}

.fees-faq-answer p {
  margin-bottom: 12px;
}

.fees-faq-answer p:last-child {
  margin-bottom: 0;
}

.faq-callout-box {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  padding: 16px 20px;
  margin-top: 12px;
  font-size: 0.88rem;
  color: #a0a6b2;
  line-height: 1.6;
}

body.light_theme .faq-callout-box {
  background: #f8f9fa;
  border-color: #e6e8ea;
  color: #5e6673;
}

.faq-footnote {
  font-size: 0.83rem;
  color: #848e9c;
  font-style: italic;
  margin-top: 8px;
}

@media screen and (max-width:1440px) {

  .fees-hero-title {
    font-size: 48px;
  }

}


@media screen and (max-width:1200px) {

  .fees-hero-title {
    font-size: 36px;
  }

  .fees-hero-subtitle {
    font-size: 18px;
  }

  .fees-hero-vector-img {
    max-height: 220px;
  }

  .agcx-fee-title {
    font-size: 28px;
  }

  .agcx-fee-desc {
    width: 100%;
    font-size: 16px;
  }

  .fee-types-heading {
    font-size: 18px;
  }

  .fee-type-text {
    font-size: 15px;
  }

}

@media screen and (max-width:991px) {

  .agcx-fee-icon-wrap {
    min-width: 70px;
    width: 70px;
    height: 70px;
    border-radius: 10px;
  }

  .fees-overview-card {
    padding: 26px;
    margin-bottom: 50px;
  }

  .fees-hero-title {
    font-size: 32px;
  }

}


@media screen and (max-width:767px) {

  .fees-hero-title {
    font-size: 24px;
  }

  .agcx-fee-box {
    gap: 16px;
    padding-right: 0px;
  }

  .fees-hero-subtitle {
    font-size: 15px;
  }

  .fees-hero-vector-img {
    max-height: 150px;
    margin: 0 auto;
  }

  .fees-mobile-value {
    font-size: 12px;
  }

  .fees-faq-question-text {
    font-size: 15px;
  }

  .fees-faq-container {
    margin-top: 30px;
    padding: 22px;
  }

  .agcx-fee-title {
    font-size: 22px;
  }

  .agcx-fee-desc {
    font-size: 14px;
  }

  .fees-overview-card {
    padding: 24px;
    margin-bottom: 30px;
  }

  .fees-nav-tabs {
    margin-bottom: 15px;
  }

  .fees-card-title {
    font-size: 19px;
  }

  .fees-withdrawal-value {
    font-size: 12px;
  }

  .fees-withdrawal-card-title {
    font-size: 15px;
  }

  .fees-badge {
    font-size: 11px;
    text-align: center;
  }

  .fees-tab-btn {
    padding: 7px 16px;
    font-size: 13px;
  }


}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/FeesPage/feesPage.css"],"names":[],"mappings":"AAAA,mDAAmD;;AAEnD;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AACjB;;;AAGA;EACE,wBAAwB;EACxB,yDAAqE;EACrE,8BAA8B;EAC9B,4BAA4B;EAC5B,WAAW;EACX,YAAY;AACd;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wDAAwD;EACxD,6BAA6B;EAC7B,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,iCAAiC;EACjC,kCAAkC;EAClC,gBAAgB;EAChB,0BAA0B;EAC1B,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,yDAA2E;AAC7E;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,2DAA2D;EAC3D,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,iCAAiC;EACjC,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;GAEG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,gBAAgB;EAChB,mCAAmC;EACnC,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,eAAe;EACf,SAAS;AACX;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,aAAa;AACf;;AAEA,yDAAyD;AACzD;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;EAC3C;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,kDAAkD;EACpD;;EAEA;IACE,cAAc;IACd,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,kDAAkD;EACpD;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,mDAAmD;EACrD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA,uDAAuD;EACvD;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;EAC3C;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,kDAAkD;EACpD;;EAEA;IACE,cAAc;IACd,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,mDAAmD;EACrD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE;IACE,eAAe;EACjB;;AAEF;;;AAGA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;;EAEE;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;AAEF;;;AAGA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;;AAGF","sourcesContent":["/* AGCX Fees Page Styling - Color Theme Compliant */\n\n.fees-container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* Main Navigation Tabs */\n.fees-nav-tabs {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 28px;\n  padding-bottom: 14px;\n  flex-wrap: wrap;\n}\n\n\n.fees_structure_page {\n  background-size: contain;\n  background-image: url(../../../../public/images/fee_structure_bg.jpg);\n  background-position: top right;\n  background-repeat: no-repeat;\n  width: 100%;\n  height: 100%;\n}\n\n/* Hero Header & Overview Card Section */\n.fees_structure_hero_sec {\n  padding-top: 40px;\n  padding-bottom: 20px;\n}\n\n.fees-gold-pill {\n  width: 36px;\n  height: 8px;\n  background: #D1AA67;\n  border-radius: 4px;\n  margin-bottom: 16px;\n  box-shadow: 0px 0px 10px rgb(209 170 103 / 70%);\n}\n\n.fees-hero-title {\n  font-size: 65px;\n  font-weight: 800;\n  color: #ffffff;\n  margin-bottom: 12px;\n  line-height: 1.15;\n}\n\nbody.light_theme .fees-hero-title {\n  color: #1e2329;\n}\n\n.fees-hero-title .gold-text {\n  background: linear-gradient(0deg, #fff 0%, #D1AA67 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-weight: 800;\n}\n\n.fees-hero-subtitle {\n  color: #9CA3AF;\n  font-size: 22px;\n  max-width: 480px;\n  line-height: 1.5;\n  margin-bottom: 0;\n}\n\nbody.light_theme .fees-hero-subtitle {\n  color: #707a8a;\n}\n\n.fees-hero-vector-img {\n  max-width: 100%;\n  height: auto;\n  max-height: 300px;\n  object-fit: contain;\n}\n\n/* Overview Box Card */\n.fees-overview-card {\n  background: rgb(255 255 255 / 5%);\n  -webkit-backdrop-filter: blur(1px);\n  margin-top: 10px;\n  backdrop-filter: blur(1px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 24px;\n  padding: 48px;\n  margin-bottom: 80px;\n  box-shadow: inset 0 5px 20px rgba(0, 0, 0, 0.35);\n}\n\nbody.light_theme .fees_structure_hero_sec {\n  background-image: url(../../../../public/images/fee_structure_bg_light.jpg);\n}\n\nbody.light_theme .fees-overview-card {\n  background: rgb(0 0 0 / 05%);\n  border-color: #e6e8ea;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);\n}\n\nbody.light_theme .fees-hero-title .gold-text {\n  background: linear-gradient(0deg, #000000 0%, #D1AA67 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n/* AGCX Fee Left Box */\n.agcx-fee-box {\n  display: flex;\n  align-items: flex-start;\n  gap: 30px;\n  padding-right: 15px;\n}\n\n.agcx-fee-icon-wrap {\n  min-width: 100px;\n  width: 100px;\n  height: 100px;\n  background: rgb(209 170 103 / 5%);\n  border: 1px solid rgb(209 170 103 / 40%);\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbody.light_theme .agcx-fee-icon-wrap {\n  background: rgba(201, 168, 76, 0.08);\n  border-color: rgba(201, 168, 76, 0.5);\n}\n\n.agcx-fee-icon {\n  width: 36px;\n  height: 36px;\n  object-fit: contain;\n}\n\n.agcx-fee-title {\n  font-size: 36px;\n  font-weight: 600;\n  color: #fff;\n  margin-bottom: 6px;\n}\n\nbody.light_theme .agcx-fee-title {\n  color: #1e2329;\n}\n\n.agcx-fee-desc {\n  width: 80%;\n  font-size: 20px;\n  color: #A3A3A3;\n  line-height: 1.5;\n  margin-bottom: 0;\n}\n\nbody.light_theme .agcx-fee-desc {\n  color: #262626;\n}\n\n/* Fee Types Right Box */\n.fee-types-box {\n  padding-left: 10px;\n}\n\n.fee-types-heading {\n  font-size: 22px;\n  font-weight: 500;\n  color: #eaecef;\n  margin-bottom: 18px;\n}\n\nbody.light_theme .fee-types-heading {\n  color: #1e2329;\n}\n\n.fee-types-list {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  padding-top: 12px;\n}\n\n.fee-type-item {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.fee-type-icon {\n  width: 24px;\n  object-fit: contain;\n  margin-top: 0px;\n}\n\n.fees_icon_wrap {\n  width: 40px;\n  min-width: 40px;\n  height: 40px;\n  border: 1px solid rgb(209 170 103 / 70%);\n  border-radius: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.fee-type-text {\n  font-size: 17px;\n  line-height: 1.5;\n}\n\n.fee-type-name {\n  color: #D1AA67;\n  font-weight: 500;\n}\n\n/* body.light_theme .fee-type-name {\n  color: #b58d24;\n} */\n\n.fee-type-desc {\n  color: #A3A3A3;\n}\n\nbody.light_theme .fee-type-desc {\n  color: #2c2c2c;\n}\n\n\n.fees-card {\n  color: #fff;\n}\n\nbody.light_theme .fees-card {\n  color: #181818;\n}\n\nbody.light_theme .fees-nav-tabs {\n  border-bottom-color: #e6e8ea;\n}\n\n.fees-tab-btn {\n  background: #181a20;\n  border: 1px solid #2b313a;\n  color: #848e9c;\n  padding: 10px 24px;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.25s ease;\n}\n\nbody.light_theme .fees-tab-btn {\n  background: #f8f9fa;\n  border-color: #e6e8ea;\n  color: #707a8a;\n}\n\nbody.light_theme .fees-tab-btn.active {\n  background: rgb(201 168 76 / 80%);\n  color: #000000;\n  font-weight: 600;\n  border-color: rgb(201 168 76 / 60%);\n  box-shadow: 0 4px 14px rgba(240, 185, 11, 0.20);\n}\n\n.fees-tab-btn:hover {\n  color: #E8C97A;\n  border-color: rgb(232 201 122 / 25%);\n  background: rgb(232 201 122 / 10%);\n}\n\n.fees-tab-btn.active {\n  background: #C9A84C;\n  color: #000000;\n  font-weight: 600;\n  border-color: #C9A84C;\n  box-shadow: 0 4px 14px rgba(240, 185, 11, 0.20);\n}\n\n/* Card Container */\n.fees-card {\n  background: #181a20;\n  border: 1px solid #2b313a;\n  border-radius: 12px;\n  padding: 26px;\n  margin-bottom: 30px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);\n}\n\nbody.light_theme .fees-card {\n  background: #ffffff;\n  border-color: #e6e8ea;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);\n}\n\n.fees-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 22px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid #2b313a;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\nbody.light_theme .fees-card-header {\n  border-bottom-color: #e6e8ea;\n}\n\n.fees-card-title {\n  font-size: 1.35rem;\n  font-weight: 600;\n  color: #eaecef;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\nbody.light_theme .fees-card-title {\n  color: #1e2329;\n}\n\n.fees-badge {\n  background: rgba(240, 185, 11, 0.05);\n  color: #E8C97A;\n  font-size: 0.75rem;\n  padding: 4px 12px;\n  border-radius: 20px;\n  border: 1px solid rgba(240, 185, 11, 0.3);\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n\n/* Search Box Styling */\n.fees-search-box {\n  position: relative;\n  display: flex;\n  align-items: center;\n  min-width: 240px;\n}\n\n.fees-search-icon {\n  position: absolute;\n  left: 12px;\n  color: #848e9c;\n  font-size: 1rem;\n  pointer-events: none;\n}\n\n.fees-search-input {\n  width: 100%;\n  background: #1e2329;\n  border: 1px solid #2b313a;\n  border-radius: 8px;\n  padding: 8px 36px 8px 36px;\n  color: #eaecef;\n  font-size: 0.88rem;\n  outline: none;\n  transition: all 0.2s ease;\n}\n\nbody.light_theme .fees-search-input {\n  background: #f8f9fa;\n  border-color: #e6e8ea;\n  color: #1e2329;\n}\n\n.fees-search-input:focus {\n  border-color: #E8C97A;\n  box-shadow: 0 0 0 2px rgba(232, 201, 122, 0.15);\n}\n\n.fees-search-input::placeholder {\n  color: #848e9c;\n}\n\n.fees-search-clear {\n  position: absolute;\n  right: 10px;\n  background: transparent;\n  border: none;\n  color: #848e9c;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n}\n\n.fees-search-clear:hover {\n  color: #eaecef;\n}\n\n/* Subtab Group */\n.fees-subtab-group {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 22px;\n  flex-wrap: wrap;\n}\n\n.fees-subtab-btn {\n  background: #1e2329;\n  border: 1px solid #2b313a;\n  color: #848e9c;\n  padding: 8px 20px;\n  border-radius: 6px;\n  font-size: 0.88rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\nbody.light_theme .fees-subtab-btn {\n  background: #f8f9fa;\n  border-color: #e6e8ea;\n  color: #707a8a;\n}\n\nbody.light_theme .fees-subtab-btn.active {\n  background: rgba(240, 185, 11, 0.10);\n  color: #E8C97A;\n  border-color: rgb(232 201 122 / 50%);\n  font-weight: 500;\n}\n\n.fees-subtab-btn:hover {\n  color: #d4b25a;\n  border-color: rgba(240, 185, 11, 0.15);\n}\n\n.fees-subtab-btn.active {\n  background: rgba(240, 185, 11, 0.10);\n  color: #E8C97A;\n  border-color: rgb(232 201 122 / 50%);\n  font-weight: 500;\n}\n\n/* Table Styling (Desktop) */\n.fees-table-responsive {\n  width: 100%;\n  overflow-x: auto;\n  border-radius: 8px;\n  border: 1px solid #2b313a;\n}\n\nbody.light_theme .fees-table-responsive {\n  border-color: #e6e8ea;\n}\n\n.fees-custom-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 0;\n  background: #181a20;\n}\n\nbody.light_theme .fees-custom-table {\n  background: #ffffff;\n}\n\n.fees-custom-table th {\n  background: #1e2329;\n  color: #848e9c;\n  font-weight: 600;\n  font-size: 0.85rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding: 14px 18px;\n  border-bottom: 1px solid #2b313a;\n  text-align: left;\n}\n\nbody.light_theme .fees-custom-table th {\n  background: #f8f9fa;\n  color: #707a8a;\n  border-bottom-color: #e6e8ea;\n}\n\n.fees-custom-table td {\n  padding: 14px 18px;\n  color: #eaecef;\n  font-size: 0.9rem;\n  border-bottom: 1px solid #2b313a;\n  vertical-align: middle;\n}\n\nbody.light_theme .fees-custom-table td {\n  color: #1e2329;\n  border-bottom-color: #e6e8ea;\n}\n\n.fees-custom-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.fees-custom-table tbody tr:hover {\n  background: rgba(255, 255, 255, 0.03);\n}\n\nbody.light_theme .fees-custom-table tbody tr:hover {\n  background: #f8f9fa;\n}\n\n/* VIP Tier Badges */\n.vip-tier-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  min-width: 75px;\n  text-align: center;\n}\n\n.vip-regular {\n  background: rgba(132, 142, 156, 0.15);\n  color: #848e9c;\n  border: 1px solid rgba(132, 142, 156, 0.3);\n}\n\n.vip-1 {\n  background: rgba(14, 203, 129, 0.15);\n  color: #0ecb81;\n  border: 1px solid rgba(14, 203, 129, 0.3);\n}\n\n.vip-2 {\n  background: rgba(59, 130, 246, 0.15);\n  color: #3b82f6;\n  border: 1px solid rgba(59, 130, 246, 0.3);\n}\n\n.vip-3 {\n  background: rgba(168, 85, 247, 0.15);\n  color: #a855f7;\n  border: 1px solid rgba(168, 85, 247, 0.3);\n}\n\n.vip-4 {\n  background: rgba(249, 115, 22, 0.15);\n  color: #f97316;\n  border: 1px solid rgba(249, 115, 22, 0.3);\n}\n\n.vip-5 {\n  background: rgba(240, 185, 11, 0.2);\n  color: #f0b90b;\n  border: 1px solid rgba(240, 185, 11, 0.4);\n}\n\n/* Fiat Rules Cards */\n.fiat-rules-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 20px;\n  margin-top: 24px;\n}\n\n.fiat-rule-card {\n  background: #1e2329;\n  border: 1px solid #2b313a;\n  border-left: 4px solid #E8C97A;\n  border-radius: 8px;\n  padding: 20px;\n}\n\nbody.light_theme .fiat-rule-card {\n  background: #f8f9fa;\n  border-color: #e6e8ea;\n  border-left-color: #E8C97A;\n}\n\n.fiat-rule-card h4 {\n  color: #E8C97A;\n  font-size: 1.02rem;\n  font-weight: 600;\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.fiat-rule-card ul {\n  margin: 0;\n  padding-left: 18px;\n  color: #b7bdc6;\n  font-size: 0.88rem;\n  line-height: 1.65;\n}\n\nbody.light_theme .fiat-rule-card ul {\n  color: #474d57;\n}\n\n.fiat-rule-card ul li {\n  margin-bottom: 8px;\n}\n\n.fiat-rule-card ul li:last-child {\n  margin-bottom: 0;\n}\n\n/* Trading Footnote */\n.trading-footnote {\n  margin-top: 16px;\n  padding: 12px 16px;\n  background: #1e2329;\n  border-radius: 6px;\n  font-size: 0.83rem;\n  color: #848e9c;\n  border-left: 3px solid #E8C97A;\n}\n\nbody.light_theme .trading-footnote {\n  background: #f8f9fa;\n  color: #707a8a;\n}\n\n.fee-highlight-val {\n  font-weight: 600;\n  color: #0ecb81;\n}\n\n.fee-highlight-charge {\n  font-weight: 600;\n  color: #E8C97A;\n}\n\n/* General Mobile Card View Styles */\n.fees-mobile-cards {\n  display: none;\n}\n\n/* DEDICATED Scoped Styles ONLY for Withdrawal Fees Tab */\n.fees-withdrawal-mobile-cards {\n  display: none;\n}\n\n@media (max-width: 768px) {\n  .fees-card {\n    padding: 16px;\n  }\n\n  .fees-search-box {\n    width: 100%;\n    min-width: 100%;\n    margin-top: 8px;\n  }\n\n  .fees-tab-btn {\n    padding: 8px 20px;\n    font-size: 14px;\n  }\n\n  .fees-mobile-card-body-2col>div {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .fees-table-responsive {\n    display: none !important;\n  }\n\n  .fees-mobile-cards {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .fees-mobile-card-item {\n    background: #1e2329;\n    border: 1px solid #2b313a;\n    border-radius: 10px;\n    padding: 16px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  }\n\n  body.light_theme .fees-mobile-card-item {\n    background: #f8f9fa;\n    border-color: #e6e8ea;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);\n  }\n\n  .fees-mobile-card-title {\n    font-size: 0.95rem;\n    font-weight: 600;\n    color: #eaecef;\n    margin-bottom: 10px;\n    padding-bottom: 8px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  }\n\n  body.light_theme .fees-mobile-card-title {\n    color: #1e2329;\n    border-bottom-color: #e6e8ea;\n  }\n\n  .fees-mobile-card-header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    justify-content: space-between;\n    margin-bottom: 10px;\n    padding-bottom: 8px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  }\n\n  body.light_theme .fees-mobile-card-header {\n    border-bottom-color: #e6e8ea;\n  }\n\n  .fees-mobile-sub-label {\n    font-size: 0.85rem;\n    text-align: right;\n    color: #848e9c;\n    font-weight: 500;\n  }\n\n  .fees-mobile-card-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 8px 0;\n    border-bottom: 1px dashed rgba(255, 255, 255, 0.08);\n  }\n\n  .fees-mobile-card-row:last-child {\n    border-bottom: none;\n  }\n\n  body.light_theme .fees-mobile-card-row {\n    border-bottom-color: rgba(0, 0, 0, 0.06);\n  }\n\n  .fees-mobile-label {\n    font-size: 0.82rem;\n    color: #848e9c;\n    font-weight: 500;\n  }\n\n  body.light_theme .fees-mobile-label {\n    color: #707a8a;\n  }\n\n  .fees-mobile-value {\n    font-size: 0.88rem;\n    font-weight: 600;\n    color: #eaecef;\n    text-align: right;\n  }\n\n  body.light_theme .fees-mobile-value {\n    color: #1e2329;\n  }\n\n  /* Specific styles for Withdrawal Fees Tab cards ONLY */\n  .fees-withdrawal-mobile-cards {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .fees-withdrawal-card-item {\n    background: #1e2329;\n    border: 1px solid #2b313a;\n    border-radius: 10px;\n    padding: 16px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  }\n\n  body.light_theme .fees-withdrawal-card-item {\n    background: #f8f9fa;\n    border-color: #e6e8ea;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);\n  }\n\n  .fees-withdrawal-card-title {\n    font-size: 1.05rem;\n    font-weight: 700;\n    color: #E8C97A;\n    margin-bottom: 10px;\n    padding-bottom: 8px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  }\n\n  body.light_theme .fees-withdrawal-card-title {\n    color: #1e2329;\n    border-bottom-color: #e6e8ea;\n  }\n\n  .fees-withdrawal-card-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 8px 0;\n    border-bottom: 1px dashed rgba(255, 255, 255, 0.08);\n  }\n\n  .fees-withdrawal-card-row:last-child {\n    border-bottom: none;\n  }\n\n  body.light_theme .fees-withdrawal-card-row {\n    border-bottom-color: rgba(0, 0, 0, 0.06);\n  }\n\n  .fees-withdrawal-label {\n    font-size: 0.82rem;\n    color: #848e9c;\n    font-weight: 500;\n  }\n\n  body.light_theme .fees-withdrawal-label {\n    color: #707a8a;\n  }\n\n  .fees-withdrawal-value {\n    font-size: 0.88rem;\n    font-weight: 600;\n    color: #eaecef;\n    text-align: right;\n  }\n\n  body.light_theme .fees-withdrawal-value {\n    color: #1e2329;\n  }\n}\n\n/* FAQ Section Styles */\n.fees-faq-container {\n  margin-top: 40px;\n  background: #181a20;\n  border: 1px solid #2b313a;\n  border-radius: 12px;\n  padding: 32px;\n  margin-bottom: 50px;\n}\n\nbody.light_theme .fees-faq-container {\n  background: #ffffff;\n  border-color: #e6e8ea;\n}\n\n.fees-faq-header {\n  margin-bottom: 28px;\n}\n\n.fees-faq-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #eaecef;\n  margin-bottom: 6px;\n}\n\nbody.light_theme .fees-faq-title {\n  color: #1e2329;\n}\n\n.fees-faq-subtitle {\n  font-size: 0.92rem;\n  color: #848e9c;\n  margin: 0;\n}\n\n.fees-faq-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.fees-faq-item {\n  border-bottom: 1px solid #2b313a;\n  padding: 20px 0;\n}\n\n.fees-faq-item:last-child {\n  border-bottom: none;\n}\n\nbody.light_theme .fees-faq-item {\n  border-bottom-color: #e6e8ea;\n}\n\n.fees-faq-question-btn {\n  width: 100%;\n  background: transparent;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0;\n  text-align: left;\n  cursor: pointer;\n}\n\n.fees-faq-question-text {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #eaecef;\n  transition: color 0.2s;\n}\n\nbody.light_theme .fees-faq-question-text {\n  color: #1e2329;\n}\n\n.fees-faq-icon {\n  color: #848e9c;\n  font-size: 1.25rem;\n  transition: color 0.2s ease;\n}\n\n.fees-faq-question-btn:hover .fees-faq-icon {\n  color: #E8C97A;\n}\n\n.fees-faq-answer {\n  margin-top: 14px;\n  color: #b7bdc6;\n  font-size: 0.92rem;\n  line-height: 1.65;\n}\n\nbody.light_theme .fees-faq-answer {\n  color: #474d57;\n}\n\n.fees-faq-answer p {\n  margin-bottom: 12px;\n}\n\n.fees-faq-answer p:last-child {\n  margin-bottom: 0;\n}\n\n.faq-callout-box {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 8px;\n  padding: 16px 20px;\n  margin-top: 12px;\n  font-size: 0.88rem;\n  color: #a0a6b2;\n  line-height: 1.6;\n}\n\nbody.light_theme .faq-callout-box {\n  background: #f8f9fa;\n  border-color: #e6e8ea;\n  color: #5e6673;\n}\n\n.faq-footnote {\n  font-size: 0.83rem;\n  color: #848e9c;\n  font-style: italic;\n  margin-top: 8px;\n}\n\n@media screen and (max-width:1440px) {\n\n  .fees-hero-title {\n    font-size: 48px;\n  }\n\n}\n\n\n@media screen and (max-width:1200px) {\n\n  .fees-hero-title {\n    font-size: 36px;\n  }\n\n  .fees-hero-subtitle {\n    font-size: 18px;\n  }\n\n  .fees-hero-vector-img {\n    max-height: 220px;\n  }\n\n  .agcx-fee-title {\n    font-size: 28px;\n  }\n\n  .agcx-fee-desc {\n    width: 100%;\n    font-size: 16px;\n  }\n\n  .fee-types-heading {\n    font-size: 18px;\n  }\n\n  .fee-type-text {\n    font-size: 15px;\n  }\n\n}\n\n@media screen and (max-width:991px) {\n\n  .agcx-fee-icon-wrap {\n    min-width: 70px;\n    width: 70px;\n    height: 70px;\n    border-radius: 10px;\n  }\n\n  .fees-overview-card {\n    padding: 26px;\n    margin-bottom: 50px;\n  }\n\n  .fees-hero-title {\n    font-size: 32px;\n  }\n\n}\n\n\n@media screen and (max-width:767px) {\n\n  .fees-hero-title {\n    font-size: 24px;\n  }\n\n  .agcx-fee-box {\n    gap: 16px;\n    padding-right: 0px;\n  }\n\n  .fees-hero-subtitle {\n    font-size: 15px;\n  }\n\n  .fees-hero-vector-img {\n    max-height: 150px;\n    margin: 0 auto;\n  }\n\n  .fees-mobile-value {\n    font-size: 12px;\n  }\n\n  .fees-faq-question-text {\n    font-size: 15px;\n  }\n\n  .fees-faq-container {\n    margin-top: 30px;\n    padding: 22px;\n  }\n\n  .agcx-fee-title {\n    font-size: 22px;\n  }\n\n  .agcx-fee-desc {\n    font-size: 14px;\n  }\n\n  .fees-overview-card {\n    padding: 24px;\n    margin-bottom: 30px;\n  }\n\n  .fees-nav-tabs {\n    margin-bottom: 15px;\n  }\n\n  .fees-card-title {\n    font-size: 19px;\n  }\n\n  .fees-withdrawal-value {\n    font-size: 12px;\n  }\n\n  .fees-withdrawal-card-title {\n    font-size: 15px;\n  }\n\n  .fees-badge {\n    font-size: 11px;\n    text-align: center;\n  }\n\n  .fees-tab-btn {\n    padding: 7px 16px;\n    font-size: 13px;\n  }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
